module.exports = __webpack_public_path__ + "static/hyperv_45.41304bcf.png";